module.exports = __webpack_public_path__ + "img/loading_spinner_animated.f2a78f83.svg";